import { Address, erc20Abi } from "viem";
import { useReadContract } from "wagmi";
import { mergeQueryStates } from "../../formatters/mergeQueryStates";
import { FetchData } from "../../types/FetchData";
import { metadataQueryConfig } from "../query-config/queryConfig";

export interface Token {
  symbol?: string;
  decimals?: number;
}

// todo reconsider optional param token ticket #218
export const useToken = (asset?: Address): FetchData<Token> => {
  const { data: decimals, ...decimalRest } = useReadContract({
    address: asset,
    abi: erc20Abi,
    functionName: "decimals",
    query: { ...metadataQueryConfig, enabled: !!asset },
  });

  const { data: symbol, ...symbolRest } = useReadContract({
    address: asset,
    abi: erc20Abi,
    functionName: "symbol",
    query: { ...metadataQueryConfig, enabled: !!asset },
  });

  return {
    ...mergeQueryStates([decimalRest, symbolRest]),
    data: {
      symbol,
      decimals,
    },
  };
};
